interface Props {
    className: string;
    onClick?: () => void;
    title?: string
}
export default function emfExpandIcon({ className, onClick, title }: Props) {
    return (
        <svg onClick={onClick} className={className} id="expand" xmlns="http://www.w3.org/2000/svg" width="12.864" height="12.864" viewBox="0 0 12.864 12.864">
            <title>{title}</title>
            <g id="Group_193788" data-name="Group 193788" transform="translate(-1813.293 -523.293)">
                <g id="Group_193787" data-name="Group 193787" transform="translate(1820.996 524)">
                    <path id="Path_29412" data-name="Path 29412" d="M6.354,1.055l3.778-.025-.015,3.778" transform="translate(-5.678 -1.03)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1" />
                    <line id="Line_2653" data-name="Line 2653" x1="4.454" y2="4.454" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1" />
                </g>
                <g id="Group_193786" data-name="Group 193786" transform="translate(1814 530.996)">
                    <path id="Path_29413" data-name="Path 29413" d="M4.808,10.106l-3.778.025.015-3.778" transform="translate(-1.03 -5.677)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1" />
                    <line id="Line_2654" data-name="Line 2654" y1="4.454" x2="4.454" transform="translate(0 0)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1" />
                </g>
            </g>
        </svg>
    )
}